import { NewShipmentService } from "./service";

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(NewShipmentService);
});
